module.exports = __webpack_public_path__ + "fonts/AvenirLTW02-85Heavy.4adca482254221860dad52597d5eff35.woff2";